import React from 'react';
import './App.css'
import Posts from './Posts/Posts'
const App = () => (
   <div className="main-container">
   <h1 className="main-heading">welcome to a modern logistics company</h1>
  
<Posts />
   </div>



   );
export default App;